import { motion } from "motion/react";
import { Magnetic } from "../ui/Magnetic";
import { Reveal } from "../ui/Reveal";
import { SocialIcon } from "../ui/Icons";
import { profile } from "../../data/content";

export function Contact() {
  return (
    <section id="contact" className="relative overflow-hidden">
      {/* glow backdrop */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[34rem] w-[34rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/15 blur-[150px]" />

      <div className="section relative">
        <div className="mx-auto max-w-4xl px-6 text-center md:px-10">
          <Reveal>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.45em] text-muted">
              05 · Contact
            </p>
          </Reveal>

          <h2 className="font-display text-5xl font-extrabold leading-[0.95] tracking-tight text-white md:text-7xl">
            <span className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "110%" }}
                whileInView={{ y: "0%" }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              >
                Let&apos;s create
              </motion.span>
            </span>
            <span className="block overflow-hidden pb-2">
              <motion.span
                className="text-gradient-animated block"
                initial={{ y: "110%" }}
                whileInView={{ y: "0%" }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.12 }}
              >
                something extraordinary.
              </motion.span>
            </span>
          </h2>

          <Reveal delay={0.25}>
            <p className="mx-auto mt-7 max-w-lg text-lg text-white/55">
              Have an idea worth building? I&apos;m currently open to freelance
              projects and full-time opportunities.
            </p>
          </Reveal>

          <Reveal delay={0.35}>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Magnetic strength={0.4}>
                <a
                  href={`mailto:${profile.email}`}
                  className="group inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-primary via-secondary to-accent bg-[length:200%_auto] px-10 py-4 text-base font-semibold text-white shadow-xl shadow-primary/30 transition-all duration-500 hover:bg-right hover:shadow-primary/50"
                  data-cursor
                >
                  <span>{profile.email}</span>
                  <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                </a>
              </Magnetic>
              <Magnetic strength={0.4}>
                <a
                  href={`tel:+91${profile.phone}`}
                  className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/5 px-10 py-4 text-base font-semibold text-white backdrop-blur transition-all duration-500 hover:bg-white/10"
                  data-cursor
                >
                  <span>{profile.phone}</span>
                </a>
              </Magnetic>
            </div>
          </Reveal>

          <Reveal delay={0.45}>
            <div className="mt-12 flex items-center justify-center gap-3">
              {profile.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  className="grid h-11 w-11 place-items-center rounded-full border border-white/10 bg-white/5 text-white/60 transition-all duration-300 hover:-translate-y-1 hover:border-white/30 hover:text-white"
                  data-cursor
                >
                  <SocialIcon name={s.icon} className="h-4 w-4" />
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative border-t border-white/8">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 py-8 md:flex-row md:px-10">
          <p className="font-mono text-xs text-muted">
            © 2026 {profile.name}. Crafted with <span className="text-primary">Three.js</span> + <span className="text-accent">Motion</span>.
          </p>
          <a
            href="#top"
            className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-muted transition-colors hover:text-white"
            data-cursor
          >
            Back to top
            <span className="transition-transform duration-300 group-hover:-translate-y-1">↑</span>
          </a>
        </div>
      </footer>
    </section>
  );
}
